/**
 * One breakpoint for the whole app: below it the shell drops the left sidebar for a
 * bottom tab bar, and the trading pages stack chart-over-config. Kept equal to the
 * value `ResponsiveTradingLayout` already stacked at so there is no in-between mode
 * (sidebar + stacked chart) that nobody tests.
 */
export const MOBILE_BREAKPOINT = 992;

/** Height of the bottom tab bar, excluding the iOS home-indicator inset. */
export const BOTTOM_NAV_HEIGHT = 56;

/** Minimum comfortable touch target — Apple HIG / Material both land near 44px. */
export const TOUCH_TARGET = 44;
